export default {
    mounted() {
        this.$nextTick(() => {
            this.$weblog.getOriginWeblog().plugins.radar.fmp();
        });
    },
};